<template>
  <div class="search-engine">
    <div class="search-engine__block">
      <input
        type="text"
        name="q"
        class="search-engine__input"
        :placeholder="getPlaceholder()"
        @click="handleOpen($event)"
        @input="handlerInput($event)"
      />
      <transition name="fade">
        <div
          v-if="Object.keys(result).length > 0 && openItems"
          class="search-engine__result"
          @wheel.prevent
        >
          <PerfectScrollbar class="search-engine__elements">
            <div
              v-if="result.products && result.products.items && showItemInSection.length"
              class="search-engine__middle"
            >
              <h6
                v-if="result.messages && result.messages.sectionsTitle"
                class="search-engine__title"
              >
                {{ result.messages.sectionsTitle }}
              </h6>
              <div>
                <p v-for="section in showItemInSection" class="search-engine__section">
                  {{ section.name }} {{ result.messages.to }}
                  <a :href="section.url">{{ result.query }}</a>
                </p>
              </div>
            </div>
            <div v-if="items?.length" class="search-engine__middle">
              <h6 v-if="result.messages && result.messages.itemsTitle" class="search-engine__title">
                {{ result.messages.itemsTitle }}
              </h6>
              <div class="search-items">
                <div class="search-products">
                  <SearchProduct
                    v-for="item in items"
                    :key="item?.offer?.id || item.id"
                    :result="item"
                  />
                </div>
              </div>
            </div>
          </PerfectScrollbar>
          <div
            v-if="result.products && result.products.items && result.products.items.length"
            class="search-engine__bottom"
          >
            <a
              v-if="result.messages && result.messages.allResults"
              :href="result.url"
              class="def-button"
              >{{ result.messages.allResults }}</a
            >
          </div>
        </div>
      </transition>
    </div>
    <svg width="20px" height="20px" class="search-engine__icon">
      <use xlink:href="#svg-magnifying"></use>
    </svg>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import SearchProduct from '@components/Search/SearchProduct/SearchProduct.vue';

export default {
  name: 'SearchEngine',
  components: {
    SearchProduct,
    PerfectScrollbar,
  },
  props: {
    params: {
      type: Object,
      default: () => ({
        ajax: {
          url: '/ajax/',
          data: {
            action: 'search',
            ajax: 'y',
            lang: 'ru',
            q: 'safd',
          },
          searchName: 'q',
          delay: 100,
        },
        placeholder: 'Поиск',
      }),
    },
  },
  data() {
    const obg = {
      result: {},
      value: '',
      timeout: '',
      openItems: false,
    };
    return obg;
  },
  computed: {
    items() {
      return this.result?.products?.items;
    },
    showItemInSection() {
      const sections = this.result?.sections?.slice(1);
      return sections;
    },
  },
  methods: {
    handlerInput(e) {
      const { params } = this;
      let delay = 1000;
      if (params && params.ajax && params.ajax.searchName) {
        delay = params.ajax.searchName;
      }
      this.value = e.target.value;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.gerSearchElements.bind(this), delay);
    },
    gerSearchElements: async function () {
      try {
        const { params } = this;

        if (
          params &&
          params.ajax &&
          params.ajax.url &&
          params.ajax.searchName &&
          this.value !== ''
        ) {
          const { data } = params.ajax;
          data[params.ajax.searchName] = this.value;
          const response = await axios.get(params.ajax.url, { params: data });
          this.result = response.data;
          this.openItems = true;
        } else {
          this.result = {};
        }
      } catch (err) {
        console.error(err);
      }
    },
    handleOpen() {
      if (this.value === '') this.result = {};
      this.openItems = !this.openItems;

      if (this.openItems) {
        document.addEventListener('click', this.handlerAnotherClick);
      } else {
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
    handlerAnotherClick({ target }) {
      const parent = target.closest('.search-engine__block');
      if (!parent) {
        this.openItems = false;
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
    getValue() {
      if (this.$attrs.value != undefined) {
        return this.$attrs.value;
      }
      return '';
    },
    getPlaceholder() {
      if (this.$attrs.result.placeholder != undefined) {
        return this.$attrs.result.placeholder;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.search-engine {
  display: inline-flex;
  position: relative;
  flex-grow: 1;
  max-width: 520px;
  width: 100%;

  &__icon {
    position: absolute;
    width: 22px;
    height: 23px;
    top: 50%;
    transform: translateY(-50%);
    right: 13px;
    pointer-events: none;
    z-index: 10;
  }

  &__input {
    height: 56px;
    padding: 0px 16px;
    width: 100%;
    border: 1px solid #dfdfdf;
    font-weight: 500;
    font-size: rem(16);
    line-height: 140%;
    color: #757575;
    cursor: text;
    &::placeholder {
      color: #757575;
      font-size: rem(16);
    }
  }

  &__result {
    position: absolute;
    width: 100%;
    z-index: 2;
    top: calc(100% + 1px);
  }
  &__elements {
    padding: 8px 8px 4px;
    background: #f7f8f9;
    max-height: 388px;
    overflow-y: auto;
    box-shadow: 0px -4px 5px rgba(47, 76, 120, 0.1);
    @include point-md {
      padding: 16px 24px 4px;
    }
  }

  &__block {
    width: 100%;
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    background-color: #fff;
    @include point-md {
      padding: 15px 0;
    }
  }
  &__title {
    font-size: rem(12);
    line-height: 100%;
    color: #757575;
    margin-bottom: 8px;
  }
  &__section {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 15px;
    a {
      color: #618eaf;
    }
  }
  &__middle {
    border-bottom: 1px solid #dfdfdf;
    margin-bottom: 15px;
  }
}
.search-products {
  display: grid;
  grid-row-gap: 4px;
}
</style>
